<div class="topline">
  <h2>Brands</h2>
  <button mat-raised-button color="primary" (click)="addBrand()">Add Brand</button>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Brand Name</th>
      <td mat-cell *matCellDef="let brand">{{brand.name}}</td>
    </ng-container>

    <ng-container matColumnDef="accountId">
      <th mat-header-cell *matHeaderCellDef>Account ID</th>
      <td mat-cell *matCellDef="let brand">{{brand.accountId}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let brand">
        <button
          mat-icon-button
          class="snowman-menu-trigger"
          [matMenuTriggerFor]="brandActionsMenu"
          [matMenuTriggerData]="{ brand: brand }"
          (click)="$event.stopPropagation()"
          aria-label="Brand actions"
          >
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editBrand(row)"></tr>
  </table>

  @if (loading) {
    <div class="loading">Loading...</div>
  }
  @if (!loading && items.length === 0) {
    <div class="empty">There are no snacks/rewards to show.</div>
  }
</div>

<mat-menu #brandActionsMenu="matMenu">
  <ng-template matMenuContent let-brand="brand">
    <button mat-menu-item (click)="$event.stopPropagation(); editBrand(brand)">Edit brand</button>
    <button mat-menu-item (click)="deleteBrand($event, brand)">Delete brand</button>
  </ng-template>
</mat-menu>
